__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-29-1790685260-stable-dev/";